// src/pages/HomeLogin.js
import React, { useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';
import { useEventContext } from '../contexts/EventContext';
import { useNavigate } from 'react-router-dom';
import LoadingLogo from '../components/LoadingLogo';

function HomeLogin() {
  const { userInfo } = useUserContext();
  const { events, loadingEvents, refetchEvents } = useEventContext();
  const navigate = useNavigate();

  // 🔁 Fetch events au chargement
  useEffect(() => {
    if (userInfo?.username) {
      refetchEvents();
    }
  }, [userInfo]);

  // 🎯 Redirection dès que les events sont prêts
  useEffect(() => {
    if (!loadingEvents) {
      if (events.length > 0) {
        navigate('/events');
      } else {
        navigate('/Onboarding'); // ou '/create-event' si tu préfères sauter onboarding
      }
    }
  }, [loadingEvents, events, navigate]);

  return <LoadingLogo />;
}

export default HomeLogin;
